import React from 'react';
import { firestoreConnect } from 'react-redux-firebase';
import { compose } from 'redux';
import Badge from './Badge';

function BadgesList({ badges }) {
  return (
    <div className="company-list section">
      <div className="title-section">Safety Badges</div>
      {badges.map((badge) => {
        return <Badge key={badge.id} badge={badge} />;
      })}
    </div>
  );
}

export default compose(firestoreConnect())(BadgesList);
